import styled from "styled-components";
import { Link } from "gatsby";

import {
  paragraph,
  paragraphSmall,
  h5,
  h6,
  detailsSmall,
  paragraphSmallCss,
  paragraphCss,
  detailsSmallCss,
} from "@/styles/typography";

const FooterContainer = styled.footer`
  width: 100%;
  min-height: 385px;
  background: ${({ theme }) => theme.backgroundColors.secondary};
  color: ${({ theme }) => theme.textColors.secondary};
  padding-bottom: 70px;

  #hubspot-newsletter {
    form {
      a {
        color: ${({ theme }) => theme.textColors.secondary};
      }
      label {
        ${paragraphSmallCss}
      }
      input[type="email"] {
        appearance: none;
        width: 100%;
      }
      select {
        padding: 12px;
        border: 1px solid ${({ theme }) => theme.colors.primary};
        border-radius: 0;
        height: 41px;
        margin-bottom: 10px;
        color: ${({ theme }) => theme.colors.primary};
        ${detailsSmallCss}
      }
      input[type="submit"] {
        appearance: none;
        ${detailsSmallCss}
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.primary};
        background-color: ${({ theme }) => theme.backgroundColors.primary};
        transition: all 0.3s ease;
        cursor: pointer;

        @media ${({ theme }) => theme.breakpoints.hover} {
          :hover {
            background-color: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.backgroundColors.primary};
          }
        }
      }

      input {
        border: 1px solid ${({ theme }) => theme.colors.primary};
        border-radius: 0;
        padding: 12px;
        margin-bottom: 10px;
      }
      .hs-richtext {
        ${paragraphCss}
        margin-bottom: 10px;
      }
    }
  }
`;

const Footer = styled.footer`
  display: grid;
  grid-template-columns: 40% 60%;

  @media (max-width: 1150px) {
    grid-template-columns: 1fr;
    padding: 50px 0;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    padding: 20px 0;
  }
`;

const GridContainer = styled.div`
  padding: 57px 0px;

  @media ${({ theme }) => theme.breakpoints.lg} {
    padding-bottom: 0px;
  }
`;

const GridBlockLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10%;

  &:last-of-type {
    grid-template-columns: 1fr 1fr;
    margin-top: 30px;
  }

  .space-between {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }
  @media ${({ theme }) => theme.breakpoints.lg} {
    gap: 7%;
  }
`;

const GridBlock = styled.div`
  display: grid;
  grid-template-columns: 45% 55%;
  margin-top: 30px;

  .space-between {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-top: 0px;
    grid-template-columns: 1fr;
  }
`;

const GridItem = styled.div``;

const Block = styled.div<{ isNewsletterPage?: boolean | null }>`
  ${({ isNewsletterPage }) => isNewsletterPage && `
  padding: 4rem;
  `}

  .gatsby-image {
    width: 150px;
    height: auto;
    margin-bottom: 10px;
  }
`;

const LinkBlock = styled.div`
  display: flex;
  margin-top: 20px;
  padding-bottom: 15px;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-bottom: 0px;
    gap: 20px;
  }
`;

const H5 = styled(h5)`
  text-transform: uppercase;
  margin-top: 50px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-top: 32px;
  }
`;

const H6 = styled(h6)`
  text-transform: uppercase;
  margin: 0 20px 0 10px;
  color: white;
`;

const Paragraph = styled(paragraph)`
  padding: 20px 0;
  width: 385px;
  @media ${({ theme }) => theme.breakpoints.sm} {
    width: 100%;
  }
`;

const ParagraphSmall = styled(paragraphSmall)``;

const GatsbyLink = styled(Link)`
  font-family: "Avenir Next";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  text-transform: uppercase;
  padding-right: 30px;
  color: #fff;
  text-decoration: none;
  transition: all 0.1s ease-in-out;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      color: ${({ theme }) => theme.textColors.tertiary};
    }
  }
`;

const GatsbyLink2 = styled(Link)`
  font-family: "Avenir Next";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  text-transform: uppercase;
  padding-right: 30px;
  color: #fff;
  transition: all 0.1s ease-in-out;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      color: ${({ theme }) => theme.textColors.tertiary};
    }
  }
`;

const ALink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.1s ease-in-out;

  .gatsby-image-social {
    width: 25px;
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    h6 {
      display: none;
    }
    img {
      margin-right: 32px;
    }
  }
  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      filter: ${({ theme }) => theme.filter.gold};
    }
  }
`;

const InputContainer = styled.div`
  position: relative;
  margin-top: 20px;
  @media ${({ theme }) => theme.breakpoints.xs} {
    width: 90%;
  }
`;

const Input = styled.div`
  width: 100%;
  padding: 11px 20px;
  border: 1px solid #ababab;

  .hs-input {
    max-width: 80%;
  }

  &::placeholder {
    color: #424242;
  }
`;

const Button = styled.button`
  position: absolute;
  right: 1px;
  top: 1px;
  bottom: 1px;
  border: 0;
  border-left: 2px solid #d9d9d9;
  background: 0;
  padding: 12px 9px;
  font-family: "Avenir Next";
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  transition: all 0.3s ease;
  cursor: pointer;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.textColors.secondary};
    }
  }
`;

const DetailsSmall = styled(detailsSmall)`
  text-transform: uppercase;
`;

const S = {
  FooterContainer,
  Footer,
  GridContainer,
  GridBlockLinks,
  GridBlock,
  GridItem,
  Block,
  Paragraph,
  DetailsSmall,
  H5,
  H6,
  LinkBlock,
  ParagraphSmall,
  GatsbyLink,
  GatsbyLink2,
  ALink,
  InputContainer,
  Input,
  Button,
};

export default S;
